import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardReportsContext = createContext(null);

// declare provider component
const CardReportsProvider = ({ children }) => {
  const [reports, setReports] = useState(null);
  const [reportsLoading, setReportsLoading] = useState(null);
  const [reportsError, setReportsError] = useState(null);



  const setTheReports = (reports) => {
    if (logComponent('CardReportsContext')) { console.debug('CardReportsContext setTheReports'); }
    let newReports = reports && Array.isArray(reports)  ? [ ...reports ] : null;
    setReports(newReports);
  }

  const setTheReportsLoading = (reportsLoading) => {
    if (logComponent('CardReportsContext')) { console.debug('CardReportsContext setTheReportsLoading'); }
    let newReportsLoading = reportsLoading;
    setReportsLoading(newReportsLoading);
  }

  const setTheReportsError = (reportsError) => {
    if (logComponent('CardReportsContext')) { console.debug('CardReportsContext setTheReportsError'); }
    let newReportsError = reportsError;
    setReportsError(newReportsError);
  }



  const cardState = useMemo(() => ({
    reports,
    reportsLoading,
    reportsError,
    setReports: setTheReports,
    setReportsLoading: setTheReportsLoading,
    setReportsError: setTheReportsError
  }), [
    reports,
    reportsLoading,
    reportsError
]);

  return (
    <CardReportsContext.Provider value={ cardState }>
      {children}
    </CardReportsContext.Provider>
  );
}

// export provider and context
export { CardReportsContext, CardReportsProvider };